import React, { useContext } from 'react';
import {
	EditVideoContext,
	IEditVideoContext,
} from 'modules/Entertainment/Videos/EditVideo/editVideoState/editVideoContext';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './DownloadBtn.module.scss';

const DownloadBtn: React.FC = () => {
	const { videoFilePath } = useContext<IEditVideoContext>(EditVideoContext);

	return (
		<div className={style.container}>
			<BlobDownloader
				filePath={videoFilePath}
				fileExtension="mp4"
				fileName="video"
				label="downloadVideoFileButton"
			/>
		</div>
	);
};

export default DownloadBtn;
